<script>
    export let src = '';
    export let alt = 'Image';
    
    if (!src.includes('http') && !src.includes('225304.selcdn.ru')) {
        src = 'https://225304.selcdn.ru/miin/' + src;
    }
</script>

{#if location.hostname !== 'localhost'}
    <img src="/resize?imaginary=true&url={src}&width=500&areaheight=450&quality=85&compression=7" alt="{alt}" {...$$restProps}>
{:else}
    <img src="{src}" alt="{alt}" {...$$restProps} />
{/if}
